import { shouldShowHeader } from './locale-header.module';

App.namespace.wrap('components.locale_header', (countries, userGeoCountryCode) => {
  const $select = $('#country-preference');
  const $continueButton = $('.c-country-preference__continue');
  const $header = $('.c-country-preference__wrap');
  const $closeButton = $('.c-country-preference__close');

  const localeManager = App.components.locale_manager;
  const countryCodeUrlToggle = window.location.search.match('toggle-country=([A-Z]{2})');
  const userGeoCountryCodeToggle = countryCodeUrlToggle && countryCodeUrlToggle[1] ? countryCodeUrlToggle[1] : false;

  userGeoCountryCode = userGeoCountryCodeToggle || userGeoCountryCode || 'GB';

  const navigateToLocale = (targetCountryCode) => {
    const matches = countries.filter(country => country.code === targetCountryCode);

    const targetCountry = matches[0];
    if (!targetCountry) {
      throw new Error(`Could not load ${targetCountryCode} locale`);
    }

    localeManager.setLocale(targetCountry.code);
    window.location = targetCountry.homepageUrl;
  };

  const getCountryNameFromCode = (code) => {
    return window.__TGV_COUNTRIES.filter(e => e.code === code)[0].name;
  };

  const getCountryShortNameFromCode = (code) => {
    return window.__TGV_COUNTRIES.filter(e => e.code === code)[0].shortName;
  };

  const updateCountriesData = () => {
    const pageCountry = getCountryNameFromCode(window.__TGV_ISO_COUNTRY_CODE);
    const userCountry = getCountryNameFromCode(userGeoCountryCode);

    $continueButton.text(`Go to ${getCountryShortNameFromCode(userGeoCountryCode)} site`);

    $('.c-country-preference__desc').html(`
            You are currently browsing venues in <b>${pageCountry}</b>
            but we’ve detected your location as <b>${userCountry}</b>.
        `);
  };

  const showHeader = () => {
    $header.slideDown({
      duration: 200,
    });
  };

  const hideHeader = () => {
    $header.slideUp({
      duration: 200,
    });
  };

  const init = () => {
    if (!shouldShowHeader({
      showOnThisPage: window.__TGV_SHOW_COUNTRY_HEADER,
      locale: localeManager.getInitialLocale(),
      userCountryCode: userGeoCountryCode,
      pageCountryCode: window.__TGV_ISO_COUNTRY_CODE,
      localeCountries: window.__TGV_COUNTRIES,
    })) {
      return;
    }

    updateCountriesData();

    $continueButton.on('click', () => {
      navigateToLocale(userGeoCountryCode);
    });

    $select.on('change', () => {
      const code = $select.val();
      if (code === window.__TGV_ISO_COUNTRY_CODE) {
        hideHeader();
      } else {
        navigateToLocale($select.val());
      }
    });

    $closeButton.on('click', hideHeader);

    showHeader();
  };

  return {
    init,
    shouldShowHeader,
  };
});
